/* unplugin-vue-components disabled */import { render } from "./comp6.vue?vue&type=template&id=19c63b8a&scoped=true"
import script from "./comp6.vue?vue&type=script&lang=js"
export * from "./comp6.vue?vue&type=script&lang=js"

import "./comp6.vue?vue&type=style&index=0&id=19c63b8a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c63b8a"]])

export default __exports__